import { createContext, useMemo, useState } from 'react'

export type Sizes = { horizontal?: 'wide' }

interface PopupSizeContextProps {
  sizes: Sizes
  setSizes: (sizes: Sizes) => void
}

export const PopupSizeContext = createContext<PopupSizeContextProps>({
  sizes: {},
  setSizes: ({}) => {},
})

PopupSizeContext.displayName = 'PopupSizeContext'

export const PopupSizeProvider = ({ children }) => {
  const [sizes, setSizes] = useState<Sizes>({})

  const value = useMemo(() => ({ sizes, setSizes }), [sizes, setSizes])

  return <PopupSizeContext.Provider value={value}>{children}</PopupSizeContext.Provider>
}
